/* ═════════════════════════════════════════════════════════════════════════
   Declaration Sinistre - Design tokens (distinct de la charte AntD/cards)
   Style éditorial : typographie + filets + monochrome + vert sur l'actif
   ═════════════════════════════════════════════════════════════════════════ */

export const T = {
  /* Couleurs */
  white: '#ffffff',
  paper: '#fafaf9',
  ink: '#0b0f14',
  inkSoft: '#2a3340',
  inkMuted: '#5a6676',
  inkLight: '#8a95a5',
  inkGhost: '#d4d9e0',
  line: '#e7e9ee',
  lineSoft: '#f1f2f5',

  /* Accents - usage parcimonieux */
  brand: '#1a6b3c',
  brandDark: '#134d2b',
  brandSoft: '#ebf4ee',
  brandLine: '#c7e0cf',

  /* Sémantiques discrets */
  danger: '#b42318',
  dangerSoft: '#fef3f2',
  warn: '#b54708',
  warnSoft: '#fffaeb',

  /* Rayon / ombres (très discrets) */
  r: { xs: 3, sm: 5, md: 8, lg: 12 },
  shadow: {
    xs: '0 1px 1px rgba(12,15,20,0.04)',
    sm: '0 1px 2px rgba(12,15,20,0.06)',
    md: '0 4px 12px rgba(12,15,20,0.06)',
  },

  /* Typo */
  fontBody: "'Inter', 'DM Sans', -apple-system, system-ui, sans-serif",
  fontMono: "'JetBrains Mono', ui-monospace, monospace",
};

/* Classe helper : petite capitale de section */
export const SECTION_LABEL = {
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: '1.4px',
  textTransform: 'uppercase',
  color: T.inkMuted,
  marginBottom: 14,
};

/* Champ de section - filet gauche, pas de card */
export const SECTION_RULE = {
  borderLeft: `2px solid ${T.line}`,
  paddingLeft: 22,
  marginBottom: 36,
};

export const SECTION_RULE_ACTIVE = {
  borderLeft: `2px solid ${T.brand}`,
};

export const FIELD_HINT = {
  fontSize: 11.5,
  color: T.inkMuted,
  marginTop: 4,
  lineHeight: 1.5,
};

export const H_TITLE = {
  fontSize: 24,
  fontWeight: 600,
  color: T.ink,
  letterSpacing: '-0.01em',
  margin: 0,
  lineHeight: 1.25,
};

export const H_SUB = {
  fontSize: 14,
  color: T.inkMuted,
  margin: '6px 0 0',
  lineHeight: 1.5,
};
